export const PERMISSION_LEVEL_ENUM = {
    NOT_SET: 0,
    GUEST: 1,
    REGULAR: 2,
    SUBSCRIPTION: 3,
};

const filtersConfig = [
    [
        {
            id: 'gender',
            title: 'Gender',
        },
        {
            id: 'generation',
            title: 'Generation',
        },
    ],
    [
        {
            id: 'ethnicity',
            title: 'Ethnicity',
        },
    ],
    [
        {
            id: 'income',
            title: 'Income',
        },
    ],
    [
        {
            id: 'area',
            title: 'Area',
        },
        {
            id: 'region',
            title: 'Region',
        },
    ],
    [
        {
            id: 'dietType',
            title: 'Diet type',
        },
        {
            id: 'hasKids',
            title: 'Has kids in household',
        },
    ],
];

export function getNormalizedFilters(rawFilters) {
    return filtersConfig.map(
        filtersColumn => filtersColumn
            .map(
                filterBlock => ({
                    ...filterBlock,
                    options: rawFilters[filterBlock.id],
                })
            )
            .filter(
                filterBlock => filterBlock.options.length > 0
            )
    );
}

export const CATEGORIES = [
    {
        id: 3,
        path: 'triggers',
        title: 'Triggers',
        permissionLevel: PERMISSION_LEVEL_ENUM.REGULAR,
    },
    {
        id: 2,
        path: 'occasions',
        title: 'Occasions',
        permissionLevel: PERMISSION_LEVEL_ENUM.REGULAR,
    },
    {
        id: 4,
        path: 'needs',
        title: 'Needs',
        permissionLevel: PERMISSION_LEVEL_ENUM.SUBSCRIPTION,
    },
    {
        id: 1,
        path: 'the-decision',
        title: 'Decisions',
        permissionLevel: PERMISSION_LEVEL_ENUM.SUBSCRIPTION,
    },
];

export function getCategoryId(name) {
    const category = CATEGORIES.find(({ path }) => path === name);

    if (!category) return 0;
    return category.id;
}

export function getCategoryPath(id) {
    const category = CATEGORIES.find(category => category.id === id);

    if (!category) return 'other';
    return category.path;
}

export function getCategoryPermissionLevel(id) {
    const category = CATEGORIES.find(category => category.id === id);

    if (!category) return PERMISSION_LEVEL_ENUM.GUEST;
    return category.permissionLevel;
}

export const microDriversConfig = [
    "Logistics",
    "Efforts/energy",
    "Efforts / energy",
    "Most convenient",
    "Finance",
    "Fit into routine / family",

    "Specific craving",
    "Health & diet",
    "Emotion",
    "Appetite / function",
    "Mission Driven",

    "Something special / indulgence",
    "Something new / a recommendation",
    "Social",
    "Menu that maximized my choices",
];

export function sortMicroDrivers(a, b) {
    return microDriversConfig.indexOf(a) < microDriversConfig.indexOf(b) ? -1 : 1;
}